import { Stack, Tooltip, Typography } from "@mui/material";

export interface TableCellOwner2LinesProps {
  userName?: string;
  groupName?: string;
  ellipsis?: boolean;
}

const TableCellOwner2Lines: React.FC<TableCellOwner2LinesProps> = ({ userName, groupName, ellipsis = true }) => {
  return (
    <Stack sx={{ textWrap: "nowrap", wordBreak: "break-word", width: "100%" }}>
      <Tooltip title={userName?.replaceAll("@", " @ ")} placement="right">
        <Typography
          sx={
            ellipsis
              ? { overflow: "hidden", textOverflow: "ellipsis" }
              : { whiteSpace: "normal !important", wordBreak: "break-word" }
          }
          fontWeight={500}
        >
          {userName?.replaceAll("@", " @ ")}
        </Typography>
      </Tooltip>
      <Tooltip title={groupName?.replaceAll("_", " ")} placement="right">
        <Typography
          color="text.secondary"
          variant="body2"
          sx={
            ellipsis
              ? (theme) => ({ ...theme.helpers(theme).ellipsis })
              : { whiteSpace: "normal !important", wordBreak: "break-word" }
          }
        >
          {groupName?.replaceAll("_", " ")}
        </Typography>
      </Tooltip>
    </Stack>
  );
};

export default TableCellOwner2Lines;
